<template>
  <v-container v-if='isVisible' style="height: 400px">
    <v-row class="fill-height" align-content="center" justify="center">
      <v-col class="subtitle-1 text-center" cols="12">
        Aguarde...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="blue darken-3"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "ProgressBar",
  props: ['isVisible']
};
</script>